<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-resign`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 13c0 3.314 2.69 6 6 6s6-2.686 6-6-2.69-6-6-6-6 2.686-6 6zm6-10c5.52 0 10 4.477 10 10s-4.48 10-10 10-10-4.477-10-10S15.48 3 21 3zM8.25 36A8.226 8.226 0 008 38v2h16.05a1 1 0 011 1v2a1 1 0 01-1 1H6c-1.1 0-2-.895-2-2v-4c0-6.627 5.37-12 12-12h8.05a1 1 0 011 1v2a1 1 0 01-1 1H16c-3.73 0-6.86 2.55-7.75 6zm22.8-6.364a1 1 0 011.415 0L36 33.172l3.535-3.536a1 1 0 011.415 0l1.414 1.414a1 1 0 010 1.415L38.828 36l3.536 3.535a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.415 0L36 38.828l-3.535 3.536a1 1 0 01-1.415 0l-1.414-1.414a1 1 0 010-1.415L33.172 36l-3.536-3.535a1 1 0 010-1.415l1.414-1.414z"/></svg>
</template>
<script>

export default {
  name: 'IconResign',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
